import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../hooks/useMetaPixel';
export const OFFER_ANCHOR = '#tilbud';
export const CHECKOUT_URL = 'https://handbold-klar.impultienda.ar/checkout';
const STICKY_OFFSET = 64;
type CtaButtonProps = {
  label: string;
  /** 'offer' ruller ned til tilbudsboksen, 'checkout' åbner betalingssiden. */
  target?: 'offer' | 'checkout';
  className?: string;
};
export function CtaButton({
  label,
  target = 'offer',
  className = ''
}: CtaButtonProps) {
  const isCheckout = target === 'checkout';
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (isCheckout) {
      // Åbn betalingssiden uden for preview-iframen.
      event.preventDefault();
      trackPixelEvent('InitiateCheckout', {
        content_name: 'Håndboldklar — hele samlingen',
        value: 249,
        currency: 'DKK'
      });
      window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer');
      return;
    }
    event.preventDefault();
    const offer = document.querySelector(OFFER_ANCHOR);
    if (!offer) return;
    const top = Math.max(offer.getBoundingClientRect().top + window.scrollY - STICKY_OFFSET, 0);
    window.scrollTo({
      top,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  };
  return <a href={isCheckout ? CHECKOUT_URL : OFFER_ANCHOR} onClick={handleClick} target={isCheckout ? '_blank' : undefined} rel={isCheckout ? 'noopener noreferrer' : undefined} className={`group flex min-h-[48px] w-full items-center justify-center gap-2.5 rounded-full bg-red px-5 py-3 text-center font-display text-base font-bold uppercase tracking-wide text-white shadow-card transition-[background-color,transform] duration-150 ease-out hover:-translate-y-0.5 hover:bg-red-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-red/40 sm:text-lg ${className}`} data-id="element-64" data-mp="3jukqcvsxpk09">
      {label}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-65" data-mp="3mx7cvcejlmhq" />
    </a>;
}